import dynamic from 'next/dynamic';
import { Suspense } from 'react';
import { useEffectOnce } from 'react-use';
import { AgentPageLayout } from 'src/components/AgentPageLayout';
import { LoadingFallback } from 'src/components/LoadingFallback';
import { AnalyticsEvent, useTrackEvent } from '$analytics';

const AgentNotificationPreferencesView = dynamic(
  () =>
    import('src/views/agent-notification-preferences').then(
      (exported) => exported.AgentNotificationPreferencesView,
    ),
  { ssr: false },
);

export default function AgentAccountProfilePage() {
  const trackEvent = useTrackEvent();
  useEffectOnce(() => {
    trackEvent(AnalyticsEvent.AccountManagement, {
      eventContainer: 'notifications',
      eventTarget: 'notifications',
    });
  });

  return (
    <Suspense fallback={<LoadingFallback />}>
      <AgentNotificationPreferencesView />
    </Suspense>
  );
}

AgentAccountProfilePage.Layout = AgentPageLayout;
